// TODO move
// TODO move
// TODO move
// TODO move
export enum BfxBlotterAction {
  ACTION_ORDER_RESUME,
  ACTION_ORDER_PAUSE,
  ACTION_ORDER_VIEW_TICKET,
  ACTION_ABORT_TRANSFER,
  ACTION_EXPORT,
  ACTION_EXPORT_IMPORT,
  ACTION_FORCE_TAKE,
  ACTION_ORDER_RECAP,
  ACTION_TAKE,
  ACTION_TRANSFER,
  ACTION_VIEW_AUDIT,
  ACTION_VIEW_DETAILS,
  ACTION_VIEW_RECAP,
  // ORDERS
  ACTION_ORDER_PICKUP,
  ACTION_ORDER_WITHDRAW,
  ACTION_ORDER_ACCEPT,
  ACTION_ORDER_ACCEPT_INTO,
  ACTION_ORDER_ACCEPT_BID,
  ACTION_ORDER_ACCEPT_ASK,
  ACTION_ORDER_REJECT,
  ACTION_ORDER_ABORT,
  ACTION_ORDER_QUICKFILL,
  ACTION_ORDER_DETAILFILL,
  ACTION_ORDER_FILL_NOW,
  ACTION_ORDER_REACTIVATE,
  ACTION_ORDER_MODIFY,
  ACTION_ORDER_MODIFY_INFO,
  ACTION_ORDER_CANCEL,
  ACTION_ORDER_DUPLICATE,
  ACTION_ORDER_UNLOCK,
  ACTION_ORDER_VIEW_VWAP,
  ACTION_ORDER_ENABLE_INFLIGHT,
  ACTION_ORDER_DISABLE_INFLIGHT,
  ACTION_NET_ORDERS,
  ACTION_NET_CLEAR,
  ACTION_NET_DISABLE,
  // trade blotter
  ACTION_TRADE_CONFIRM,
  ACTION_TRADE_CANCEL,
  ACTION_TRADE_ADD_FILL_COMMENT,
  ACTION_TRADE_VIEW_DETAILS,
  ACTION_TRADE_VIEW_TRADE_DETAILS,
  ACTION_TRADE_EXPORT,
  ACTION_TRADE_VIEW_VWAP,
  // intervention blotter
  ACTION_DI_ACCEPT,
  ACTION_DI_APPROVE,
  ACTION_DI_REJECT,
  ACTION_DI_TRADER_REJECT,
  ACTION_DI_CANCEL,
  ACTION_DI_AMEND_MARKUP,
  ACTION_DI_MANUAL_PRICE,
  ACTION_DI_FWD_ROLL_PRICE,
  ACTION_DI_FWD_ROLL_CLEAR,
  ACTION_DI_FWD_ROLL_RETRY,
  ACTION_DI_UNLOCK,
  ACTION_DI_VIEW_DETAILS,
  ACTION_SPOT_RISK_SEND_TO,
  ACTION_SPOT_RISK_DISABLE_AUTO,
  ACTION_SPOT_RISK_ENABLE_AUTO,
  ACTION_SPOT_RISK_EXPORT_TO_CSV,
  // Bmark Summary
  ACTION_SPOT_RISK_SEND_TO_DEALT,
  // generic
  SEPARATOR,
  // bmhedge
  ACTION_ORDER_ACCEPT_CANCEL,
  ACTION_ORDER_REJECT_CANCEL,
  // Manual Rate Referencing
  ACTION_DI_FILL_APPROVE,
  ACTION_DI_FILL_CANCEL,
  ACTION_DI_FILL_CLEAR,
  // Ops Intervention
  ACTION_OPS_INT_VIEW_DETAILS,
  ACTION_OPS_INT_REPRICE,
  ACTION_OPS_INT_RESEND,
  ACTION_OPS_INT_CLEAR,
  ACTION_OPS_INT_CANCEL_ORDER,

  ACTION_NOP,
}
